export default class {
    constructor (COURSE_TRAINING_TYPE_ENUM, COURSE_TRAINING_PASSING_TYPE_ENUM) {
        this.COURSE_TRAINING_TYPE_ENUM = COURSE_TRAINING_TYPE_ENUM;
        this.COURSE_TRAINING_PASSING_TYPE_ENUM = COURSE_TRAINING_PASSING_TYPE_ENUM;
    }

    finalizePassingType (training) {
        if (training.type === this.COURSE_TRAINING_TYPE_ENUM.KEYS.FEEDBACK
            && training.passingType !== this.COURSE_TRAINING_PASSING_TYPE_ENUM.KEYS.OPTIONAL) {
            training.passingType = this.COURSE_TRAINING_PASSING_TYPE_ENUM.KEYS.OPTIONAL;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/services/course/version/trainingForm/index.js